
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/farms-crops-property-dust-bowl",
      function () {
        return require("private-next-pages/articles/farms-crops-property-dust-bowl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/farms-crops-property-dust-bowl"])
      });
    }
  